import { createApp } from 'vue';

//import the alert library
import VueSimpleAlert from "vue3-simple-alert-next";


//import App from './components/App.vue';
import App from './App.vue';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css';

//import some GoA CSS
import './assets/css/linkStyles.css';
import './assets/css/buttonStyles.css';

import '@fortawesome/fontawesome-free/css/all.css'

// Import the component
import HyperlinkCell from './HyperlinkCell.vue';  

const app = createApp(App);
app.component('HyperlinkCell', HyperlinkCell);
app.use(VueSimpleAlert, { reverseButtons: true });
app.mount('#app');

